import { useTranslation } from 'react-i18next';

import Button from '../../../components/buttons/Button';
import { SocialCoin } from '../../../components/SocialCoin/SocialCoin';
import { CrownRoundedIcon } from '../../../components/SVGIcons/CrownRoundedIcon';
import styles from '../Onboarding.module.scss';

export const SocialCoinTooltip = (props: { handleClick: VoidFunction }) => {
  const { t } = useTranslation();

  return (
    <>
      <p>
        <span>{t('onboarding.playWith')}</span>
        <span className={styles.coinImage}>
          <CrownRoundedIcon />
          <SocialCoin />
        </span>
        <strong>{t('common.crownCoins')} </strong>
        <span>{t('onboarding.forFunEarnLoyalty')}</span>
      </p>
      <Button btnType="main" onClick={props.handleClick}>
        {t('buttons.great')}
      </Button>
    </>
  );
};
